/**
 * @Author:
 * @Description:
 * @DateTime: Created in 23:01 2020/10/11
 */
import * as Vue from "vue-tsx-support";
import {Component, Prop, Emit} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import EnumFactory from "../../enums/enumFactory";
import CommonSelect from "./commonSelect";
import EnumEntity from 'src/enums/enumEntity';

export interface EnumSelectPropsI {
	type: number
	value?: number|null|Array<number|null>
	clearable?: boolean
	readonly?: boolean
	multiple?: boolean
	disabled?: boolean
	transfer?: boolean
	placeholder?: string
	excludeIds?: number[]
}

export interface EnumSelectEventI {
	onInput (value: number): void

	onChange (item: {value: number, label: string}|number): void
}

@Component
export default class EnumSelect extends Vue.Component<EnumSelectPropsI, EnumSelectEventI> {
	@Prop({
		type: Boolean,
		default: false
	})
	multiple!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	disabled!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	readonly!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	transfer!: boolean

	@Prop({
		type: Boolean,
		default: true
	})
	clearable!: boolean

	@Prop({
		type: Number
	})
	type!: number

	@Prop({
		type: Array,
		default() {return []}
	})
	excludeIds!: number[]

	@Prop({
		type: [Number, Array]
	})
	value!: number|null|Array<number|null>

	dataSource: Array<{name: string,id: number}> = []

	@Emit('input')
	input (value: number) {
		return value
	}

	@Emit('change')
	change (item: {value: number|string, label: string}|number|string) {
		return item
	}

	@Emit('clear')
	clear (value: number) {}

	get defaultPlaceholder () {
		let str = EnumEntity.findId(this.type).getName()
		return `请选择${str}`
	}

	async mounted () {
		let enumFactory = new EnumFactory([this.type])
		let dataSource = await enumFactory.getDictList(this.type)
		this.dataSource = dataSource.filter(i=>!this.excludeIds.includes(i.id))
	}

	render (h) {
		return (
			<CommonSelect
				transfer={this.transfer}
				class={{'wqms-select-readonly': this.readonly}}
				placeholder={this.defaultPlaceholder}
				clearable={this.clearable}
				disabled={this.disabled|| this.readonly}
				on-input={this.input}
				value={this.value}
				on-change={this.change}
				on-clear={this.clear}
				dataSource={this.dataSource}
				multiple={this.multiple}>
			</CommonSelect>
		)
	}
}
